import React from 'react';
import Brick from './BrickCore';
import EmailLayout from '../EmailLayout';
import { EmailLayoutsField } from '../../components';
import { Field } from 'redux-form';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * send an email
 *
 * [server_side]
 */
class EmailSendBrick extends Brick {
    /**
     * @param {{ emails?: object[] }|null|undefined} detailCtx
     * @returns {string|null}
     */
    getNodeDetails(detailCtx) {
        const emails = detailCtx?.emails || [];
        const layoutId = this.getOption('layout_id');
        const recipients = this.getOption('recipients');
        const parts = [];

        if (layoutId != null) {
            const emailLayout = emails.find((e) => String(e?._id) === String(layoutId));
            const label = this.localizedDetailLabel(emailLayout?.name, detailCtx, '');
            if (label)
                parts.push(label);
        }

        if (recipients != null) {
            const compactRecipients = String(recipients).replace(/\s+/g, ' ').trim();
            const truncatedRecipients = this.truncateNodeDetail(compactRecipients, 36);
            if (truncatedRecipients)
                parts.push(truncatedRecipients);
        }

        return this.joinNodeDetailParts(parts);
    }

    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, emails } = props;

        if (!emails)
            return null;

        return (
            <>
                <FormGroup row>
                    <Label for="layout_id" className="text-v-center" sm={12}>
                        { t('workflows.bricks.email.send.options.layout_id') }
                    </Label>
                    <Col sm={12}>
                        <EmailLayoutsField
                            emailLayouts={emails}
                            types={[
                                EmailLayout.LAYOUT_TYPE_CAMPAIGN,
                                EmailLayout.LAYOUT_TYPE_ACCREDITATION,
                            ]}
                            name={`bricks[${this.position}].options.layout_id`}
                            single
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="recipients" className="text-v-center" sm={12}>
                        { t('workflows.bricks.email.send.options.recipients') }
                    </Label>
                    <Col sm={12}>
                        <Field component="input" type="text" name={`bricks[${this.position}].options.recipients`} className="form-control" />
                    </Col>
                </FormGroup>
            </>
        );
    }
}

export default EmailSendBrick;
